const DocumentVisibilities = [
  { key: "public", text: "Public" },
  { key: "private", text: "Private" }
]

export default DocumentVisibilities